import { axiosGet, axiosPost } from "../../../../../react_axios/Axios";
import { GET_AIR_CONNECTION_DETAILS_ACTION_TYPE, INSERT_UPDATE_AIR_CONNECTION_ACTION_TYPE, headers, insertUpdateAirConnectionUrl, getAirConnectionDetailsUrl } from "../../../../../utils/constants";



export const insertUpdateAirConnection_action =
  (
    Remark,
    Is_Agree,
    ManualFormID,
    ServiceID2,
    VendorDetails,
    AirConnectionList
  ) =>
    async (dispatch) => {
      try {
        const params = {
          UserID: JSON.parse(sessionStorage.getItem("loginDataSS")).UserID,
          ExhibitionID: parseInt(sessionStorage.getItem("sessionExhibitionID")),
          ExhRegistrationID: parseInt(sessionStorage.getItem("ExhRegistrationIDSS")),
          Remark: Remark,
          Is_Agree: Is_Agree,
          ManualFormID: ManualFormID,
          ServiceID2: ServiceID2,
          VendorDetails: VendorDetails,
          AirConnectionList: AirConnectionList,
        };
        const res = await axiosPost(insertUpdateAirConnectionUrl, params, headers);

        dispatch({
          type: INSERT_UPDATE_AIR_CONNECTION_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (error) {
        return Promise.reject(error);
      }
    };

export const getAirConnectionDetails_action = () => async (dispatch) => {
  try {
    const params = {
      UserID: JSON.parse(sessionStorage.getItem('loginDataSS'))?.UserID || null,
      ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
      ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS') || sessionStorage.getItem('sessionExhRegistrationID'),
    }
    const res = await axiosGet(getAirConnectionDetailsUrl, params, headers)

    dispatch({
      type: GET_AIR_CONNECTION_DETAILS_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}
